import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import SUserLayout from '@slg/web-customer-shared/src/components/layouts/userLayout/SUserLayout.vue';
import { useI18n } from '@/composables';


const __default__ = {
  name: 'SettingsPage',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18n();

const items = computed(() => [
  {
    name: t('settings.profile'),
    route: 'profile',
  },
  {
    name: t('settings.security'),
    route: 'security',
  },
]);

return { __sfc: true,t, items, SUserLayout }
}

})